jQuery(document).ready(function ($) {
		
   
	
    $('.gsc-kv-pc').bgSwitcher({
        images: ['./image/kv01@2x.png','./image/kv02@2x.png','./image/kv03@2x.png'], // 切り替える背景画像を指定
        interval: 2700
    });
    
    $('.gsc-kv-sp').bgSwitcher({
        images: ['./image/kv-sp01@2x.png','./image/kv-sp02@2x.png','./image/kv-sp03@2x.png'], // 切り替える背景画像を指定
        interval: 2700
    });
    
    $(".gsc-sipe-link p .gsc-sipe-link-item").on("click", function () {
    // メイン画像に切り替えるimgのsrc取得
    img = $(this).attr("src");
    // currentクラス付け替え(枠線などを変えたい時に)
    $(".gsc-sipe-link p").removeClass("current");
    $(this).parent().addClass("current");
    // fadeOutできたらsrc変更してfadeIn
    $(".gsc-sipe-bg img").fadeOut(500, function () {
      $(".gsc-sipe-bg img")
        .attr("src", img)
        .on("load", function () {
          $(this).fadeIn(500);
        });
    });
  });
		
	$('.js-product-galleryslick01').slick({
    dots: false,
    speed: 400,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 2000,
      settings: 'unslick'
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10%'
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  $('.js-gallery').slick({
    dots: false,
    infinite: false,
    centerMode: true,
    centerPadding: "25%",
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: 0,
        infinite: true
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });

	
	
	
});


